module.exports = __webpack_public_path__ + "img/3-3-2-5-1.455f06b1.png";